import { useCallback } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useLoginDrawer } from '@/contexts/LoginDrawerContext';

/** Guest → open login drawer; authenticated → run action. */
export function useGuestAuthAction() {
  const { isAuthenticated } = useAuth();
  const { openLoginDrawer } = useLoginDrawer();

  return useCallback(
    (action: () => void) => {
      if (!isAuthenticated) {
        openLoginDrawer();
        return;
      }
      action();
    },
    [isAuthenticated, openLoginDrawer]
  );
}
